class ProductTabs extends HTMLElement {
    constructor() {
        super();

        this.tab = this.querySelectorAll('.tab-title');
        this.tabContent = this.querySelectorAll('.tab-content');
        this.link = this.querySelectorAll('.toggleLink');

        if (this.querySelector('.tabs-horizontal')) {
            if (this.tab.length > 0) {
                this.tab[0].classList.add('is-open');
            }

            if (this.tabContent.length > 0) {
                this.tabContent[0].classList.add('is-active');
            }
        }

        if (this.tab.length > 0) {
            this.tab.forEach((tab) => {
                tab.addEventListener('click', this.tabActive.bind(this));
            });
        }

        if (this.link.length > 0) {
            this.link.forEach((link) => {
                link.addEventListener('click', this.tabToggle.bind(this));
            });
        }
    }

    tabActive(event) {
        event.preventDefault();
        event.stopPropagation();

        const $this = event.currentTarget;
        const href = $this.getAttribute('href');

        if (!href) return;

        const id = href.replace('#', '');

        if (!$this.classList.contains('is-open')) {

            this.tab.forEach((element) => {
                element.classList.remove('is-open');
            });

            $this.classList.add('is-open');

            this.tabContent.forEach((element) => {
                if (element.getAttribute('id') === id) {
                    element.classList.add('is-active');
                } else {
                    element.classList.remove('is-active');
                }
            });
        }
    }

    tabToggle(event) {
        event.preventDefault();
        event.stopPropagation();

        /* IMPORTANT:
           currentTarget always gives us .toggleLink
           even when user taps its text or + icon
        */
        const $this = event.currentTarget;

        const toggleTitle = $this.closest('.toggle-title');

        if (!toggleTitle) return;

        const $content = toggleTitle.nextElementSibling;

        if (!$content || !$content.classList.contains('toggle-content')) {
            return;
        }

        if ($this.classList.contains('is-open')) {

            $this.classList.remove('is-open');

            if (window.jQuery) {
                window.jQuery($content).stop(true, true).slideUp(300);
            } else {
                $content.style.display = 'none';
            }

        } else {

            $this.classList.add('is-open');

            if (window.jQuery) {
                window.jQuery($content).stop(true, true).slideDown(300);
            } else {
                $content.style.display = 'block';
            }
        }
    }
}

customElements.define('product-tab', ProductTabs);